import { Link } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';

export default function AdminDashboard() {
  return (
    <ProtectedRoute>
      <div className="min-h-screen bg-gray-50 p-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-8">
            <h1 className="text-3xl font-black text-gray-900 mb-2">🎛️ Admin Dashboard</h1>
            <p className="text-gray-600 mb-8">Manage your blog and subscribers</p>
            
            <div className="grid md:grid-cols-2 gap-6">
              <Link
                to="/admin/email"
                className="bg-gradient-to-br from-blue-500 to-cyan-500 text-white p-8 rounded-xl hover:from-blue-600 hover:to-cyan-600 transition-all transform hover:scale-105 shadow-lg"
              >
                <div className="text-4xl mb-4">📧</div>
                <h2 className="text-xl font-bold mb-2">Email Management</h2>
                <p className="text-blue-100">Manage subscribers, send notifications, and sync with Sanity CMS</p>
              </Link>
              
              <div className="bg-gradient-to-br from-purple-500 to-pink-500 text-white p-8 rounded-xl shadow-lg opacity-75">
                <div className="text-4xl mb-4">📊</div>
                <h2 className="text-xl font-bold mb-2">Analytics</h2>
                <p className="text-purple-100">Coming soon - Blog analytics and insights</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ProtectedRoute>
  );
}